export default {
    title: '三井塑料贸易（上海）有限公司',
    subTit: 'MITSUI PLASTICS TRADING (SHANGHAI) CO., LTD',
    home: {
        changeLang: 'ZH',
    },
    pageTabbar: {
        tab1: '网站首页',
        tab2: '公司简介',
        tab3: '主营产业',
        tab4: '公司职能',
        tab5: '产品介绍',
        tab6: '仓库据点',
        tab7: '联系我们',
    },
    bottom: {
        title: 'CONTACT',
        company1: '三井塑料贸易（上海）有限公司',
        com1_span1: '地址：上海市普陀区西康路1143号鸿寿坊东塔19楼（〒200042）',
        com1_span2: '联系电话：86(21)2223-6666',
        com1_span3: '传真：86(21)2223-6699',
        com1_span4: "邮箱：PlanningSHMPS{'@'}dg.mitsui.com",
        company2: '三井塑料贸易（上海）有限公司广州分公司',
        com2_span1: '地址：广州市天河区天河路230号万菱国际中心3601室',
        com2_span2: '联系电话：020-2887-0288',
        com2_span3: '传真：020-2887-0299',

        company3: '三井塑料贸易（上海）有限公司南京分公司',
        com3_span1: '地址：南京市鼓楼区汉中路2号金陵饭店亚太商务楼8层890室',
        com3_span2: '联系电话：13472511541',
        company4: '三井塑料贸易（上海）有限公司苏州事务所',
        com4_span1: '地址：江苏省苏州市工业园区华池街88号星合广场1座30层3016室',
        com4_span2: '联系电话：13472519247',
        com4_span3: '座机：(0512)6762-8868',

        botSpan1: 'COPYRIGHT 2003-2017 MITSUI PLASTICS TRADING (SHANGHAI) CO., LTD.ALL ',
        botSpan2: 'RIGHTS RESERVED 沪ICP备12001177号-1',
        botSpan3: '沪公网安备 31010702007338号',
        botSpan4: '沪(浦)应急管危经许[2023]203699',
    },
    index: {
        banner: {
            span1: '由三井物产株式会社、三井物产（上海）贸易有限公司及三井物产（中国）有限公司共同出资于2003年成立的外商投资企业。公司注册于中国（上海）自由贸易试验区，主要从事机能材料（合成树脂原料、产品、无机化工品等）、尖端材料（电子材料等）的进出口、保税及内销业务。',
            span2: '公司作为三井物产集团机能材料及尖端材料领域的中国销售中心，在全国约30个网点，拥有各种类型的仓库，可以为各地客户提供多元化的JIT供货服务。'
        },
        one: {
            span1: 'ABOUT US<br/><br/>',
            span2: '三井塑料贸易（上海）有限公司是由三井物产株式会社、三井物产（上海）贸易有限公司及三井物产（中国）有限公司共同出资于2003年成立的外商投资企业。公司注册于中国（上海）自由贸易试验区，主要从事机能材料（合成树脂原料、产品、无机化工品等）、尖端材料（电子材料等）的进出口、保税及内销业务。公司作为三井物产集团机能材料及尖端材料领域的中国销售中心，在全国约30个网点，拥有各种类型的仓库，可以为各地客户提供多元化的JIT供货服务。',
            span3: '2018年11月设立广州分公司，通过横向发展本公司职能（库存，分销，市场开拓等），开拓在中国华南地区的业务。2019年6月设立南京事务所，同年7月设立苏州事务所，以尖端材料相关业务为中心，加速发展在江苏省，安徽省，湖北省等长江中游地区的业务。 公司将依托覆盖全国的网点及母公司三井物产集团强大的环球销售网络和综合实力，不断扩大进出口贸易、三国贸易和国内销售贸易业务，为中国的经济发展作贡献。',
        },
        two: {
            span1: '主营产业<br/><br/>',
            span2: '三井塑料贸易（上海）有限公司是三井物产集团100%出资的子公司，主要从事机能材料领域（合成树脂原料、产品、无机化工品等）和尖端材料领域（电子材料等）产品的分销。',
            span3: '<br/><br/>公司职能<br/><br/>',
            span4: '三井塑料贸易（上海）有限公司的主要职能分为：贸易、与信职能，广泛的销售网络，市场、销售力，分销、在库职能。',

        },
        three: {
            span1: '产品介绍<br/><br/>',
            span2: '三井塑料贸易（上海）有限公司分为七个营业室，分别从事工程塑料原料、机能树脂、尼龙薄膜、氯丁橡胶、钛白粉、半导体材料等产品的采购及销售。',
            span3: '<br/><br/>仓库据点<br/><br/>',
            span4: '三井塑料贸易（上海）有限公司在中国18个城市、地区设置有仓库，为客户提供快捷便利的服务。',
        },
        gs: {
            title: '三井集团网络',
            gs1: '三井物产（中国）有限公司',
            gs2: '三井物产（中国）有限公司 东北分公司',
            gs3: '三井物产（中国）有限公司 长春分公司',
            gs4: '三井物産(中国)有限公司 沈阳事务所',
            gs5: '三井物産(中国)有限公司 天津分公司',
            gs6: '三井物产（中国）有限公司 青岛分公司',
            gs7: '三井物产（中国）有限公司 呼和浩特事务所',
            gs8: '三井物产（上海）贸易有限公司',
            gs9: '三井物产（上海）贸易有限公司 武汉分公司',
            gs10: '三井物产（上海）贸易有限公司 西南分公司',
            gs11: '三井物产（上海）贸易有限公司 西南分公司 成都事务所',
            gs12: '三井物产（广东）贸易有限公司',
            gs13: '三井物产（广东）贸易有限公司 长沙事务所',
            gs14: '三井物产（香港）有限公司'
        }
    },
    company: {
        title1: '公司概要',
        line1_1_1: '公司名称(中文)',
        line1_1_2: '三井塑料贸易(上海)有限公司',
        line1_2_1: '公司名称(英文)',
        line1_2_2: 'Mitsui Plastics Trading Shanghai Co., Ltd.',
        line1_3_1: '总公司地址',
        line1_3_2: '上海市普陀区西康路1143号鸿寿坊东塔19楼（〒200042）',
        line1_4_1: '总公司注册地址',
        line1_4_2: '中国(上海)自由贸易试验区基隆路6号外高桥大厦10楼1006室',
        line1_5_1: '事业内容',
        line1_5_2: '机能材料(合成树脂原料、产品;无机化学品等);尖端材料(电子材料)等的进出口·三方贸易·保税区·中国国内销售',
        line1_6_1: '注册资金',
        line1_6_2: '30万美元',
        line1_7_1: '设立',
        line1_7_2: '2003年3月',
        line1_8_1: '出资方',
        line1_8_2: '三井物产株式会社(80%)，三井物产(中国)有限公司(10%)，三井物产(上海)贸易有限公司(10%)',
        line1_9_1: '董事长·总经理',
        line1_9_2: '伊谷良太',
        title2: '沿革',
        line2_1_1: '2003年3月',
        line2_1_2: '三井塑料贸易(上海)有限公司(MPTS)开业(保税区现地法人。三井物产株式会社80%、三井物产(中国)有限公司10%、三井物产(上海)贸易有限公司10%)',
        line2_2_1: '2004年1月',
        line2_2_2: '苏州三井国际物流贸易有限公司(MILT)开业(外商投资物流试点企业。苏州物流中心50%、三井物产株式会社40%、三井物产(中国)有限公司10%)',
        line2_3_1: '2007年1月',
        line2_3_2: '业务整合，MPTS与MILT合并，整合后的三井塑料贸易(上海)有限公司(MPTS)诞生',
        line2_4_1: '2018年11月',
        line2_4_2: '广州分公司开业',
        line2_5_1: '2019年6月',
        line2_5_2: '设立南京事务所',
        line2_6_1: '2019年7月',
        line2_6_2: '设立苏州事务所',
        line2_7_1: '2022年12月',
        line2_7_2: '南京分公司开业',
        title3: 'MPTS据点',
        line3_1_1: '总公司',
        line3_1_2: '上海市普陀区西康路1143号鸿寿坊东塔19楼(〒200042)',
        line3_1_3: 'Tel. +86-21-2223-6666',
        line3_1_4: '地铁7号线「长寿路」站直达',
        line3_2_1: '广州分公司',
        line3_2_2: '广州市天河区天河路230号万菱国际中心3601室(〒510620)',
        line3_2_3: 'Tel.+86-20-2887-0288',
        line3_3_1: '苏州事务所',
        line3_3_2: '苏州市苏州工业园区华池路88号星合广场1座30楼3016室(〒215021)',
        line3_3_3: 'Tel.+86-512-6762-8828',
        line3_4_1: '南京分公司',
        line3_4_2: '南京市汉中路2号金陵饭店亚太商务中心8楼890号室(210005)',
        line3_4_3: 'Tel. +86-134-7251-1541',
    },
    main: {
        main: {
            tit: '三井塑料贸易(上海)有限公司',
            span1: '三井物产100%出资',
            span2: '机能材料领域分销商',
        },
        item1: {
            tit: '基础建材',
            text: '太阳能，风力相关产品;PVC树脂、管道用改性剂、有机硅产品;窗框用改性剂、改性有机硅、涂料原料等'
        },
        item2: {
            tit: 'OA·家电',
            text: '高性能树脂(工程塑料、PS/ABS及改性剂)手机·汽车内饰用涂料等;有机硅产品、PCR等'
        },
        item3: {
            tit: '汽车',
            text: '改性聚丙烯;高性能树脂(工程塑料等)合成橡胶、氯丁橡胶、弹性体PCR 等'
        },
        item4: {
            tit: '包装资材原料薄膜',
            text: 'LLDPE、高机能树脂;PCR、纸制品、木片等'
        },
        item5: {
            tit: '涂料·油墨',
            text: '钛白粉 钛矿石'
        },
        item6: {
            tit: '情报·电子',
            text: '绝缘膜、铜箔(电路基板材料) 散热材料(散热板·树脂) 显示器面板用薄膜材料、有机EL材料'
        },
        item7: {
            tit: '产业机械',
            text: '电动工具、工程机械相关部件等'
        },
    },
    functions: {
        item1: {
            tit: '贸易·与信功能',
            span1: '登录客户数:4,288家',
            span2: '登录供应商数:667家(23年10月)',
            span3: '· 发挥各种金融功能',
            span4: '· 信用风险·外汇风险的应对',
            span5: '· 资金需求的应对',
        },
        item2: {
            tit: '分销·在库功能',
            span1: '· 在全国拥有33处仓库据点',
            span2: '· 可以做保税区·出口加工区的在库销售',
            span3: '· 在预测的基础上接发订单并进行合理的在库管理，缩短交货时间，稳定供应，',
            span4: '· 向汽车·家电·OA·电子零部件厂家提供JT配送服务。',
        },
        item3: {
            tit: '广泛的销售网络功能',
            span1: '· 与国内外的三井物产海外法人合作',
            span2: '· 共享商品销售战略',
            span3: '· 开拓新的销售渠道和模式',
        },
        item4: {
            tit: '市场·销售功能',
            span1: '· 拥有约90名营业部员工',
            span2: '· 不断开拓新的业务',
            span3: '· 为多种多样的终端客户提供解决方案',
            span4: '· 进行代理店性质的市场销售',
        },
    },
    products: {
        tit1: '室名',
        tit2: '商品',
        tit3: '行业',
        tit4: '用途',

        line1_1: '消费品&电器材料',
        line1_2: '泛用类热塑·热固型高分子材料，工程类热塑·热固性高分子复合材料，(PPPB,PC,PBTABS,POM,PA,PPSPPA,LCPPES,TPX PEEK,TPU等),玻璃纤维,染色·改性塑料母粒',
        line1_3: '汽车, OA机器,电动工具,家电,电子设备',
        line1_4: '精密器械,汽车配件,管路,手机,摄像头,包装膜,离型膜,反射膜,家电零部件',

        line2_1: '产业材料',
        line2_2: '合成树脂(PBT,PA,PA9T,PC,PPE,PBAT,TPU等)',
        line2_3: '汽车,电子电气等',
        line2_4: '连接器,传感器等,马达,断路器,继电器,开关等',

        line3_1: '工程塑料',
        line3_2: '工程塑料(PC、PBT、ABS,POM、PA、PPS,LCP、PES、涂料、TPU等)',
        line3_3: '汽车, OA机器, 家电、电子设备',
        line3_4: '精密器械、汽车配件，手机部件',

        line4_1: '工业树脂',
        line4_2: '改性聚丙烯、热可塑性弹性体,工程塑料(ASA，PC/ABS)信越有机硅、导电助材',
        line4_3: '汽车、家电',
        line4_4: '汽车,家电内饰、外饰零部件,汽车电池、电抗器',

        line5_1: '弹性体',
        line5_2: '氯丁橡胶、三元乙丙胶、各种合成橡胶,玻璃线绳,橡胶添加剂',
        line5_3: '汽车,一般工业,粘合剂',
        line5_4: '汽车橡胶零部件，工业橡胶零部件,粘合剂',

        line6_1: '薄膜材料',
        line6_2: '高阻隔薄膜、PE薄膜、生物降解薄膜,PE树脂、POE树脂、EVA树脂、TPU树脂,PPA、添加剂',
        line6_3: '印刷加工行业,薄膜行业,助剂行业',
        line6_4: '汽车橡胶零部件,工业橡胶零部件,粘合剂食品包装、工业包装机能薄膜、光伏材料、车衣材料,食品包装',

        line7_1: '生活资材',
        line7_2: '木片、纸制品, 木制品(板材、原木、纤维板、刨花板等),玻璃、真空隔热材料,再生树脂(再生PP，PE，PS，ABS等颗粒)',
        line7_3: '造纸、服装、食品, 建筑,家装,家电制造业,汽车、家电、OA、日化、食品',
        line7_4: '文化纸、生活用纸、工业用纸、人造粘胶纤维,食品包装等纸产品,土木建筑基材、装饰辅料、家具,家电部件, 家电、OA、汽车部件，日化、食品包装',

        line8_1: '机能性化学品',
        line8_2: '钛白粉(二氧化钛),有机硅,高分子烯烃以及烷烃，(阿尔法烯烃，二异丁烯，异构烷烃)，油脂化学品(脂肪酸，甘油)改性硅酮，密封胶添加剂,碘以及碘化物、高岭土等',
        line8_3: '涂料、油墨、塑料改性,润滑油，金属加工油，添加剂，化妆品,橡胶成型，薄膜、密封胶,粘合剂，电子材料，轮胎等',
        line8_4: '涂料、油墨、塑料改性，润滑油添加剂，工业润滑油,轮胎胶粘剂，化妆品,汽车家电零部件，离型膜,工业·建筑用密封胶电子零件等',

        line9_1: '综合添加剂',
        line9_2: '树脂改性剂(MBS、ACR、阻燃剂、开口剂、耐磨剂、滑剂透明成核剂等),环氧增韧剂,发泡聚丙烯、PVC糊状树脂、PO基料等',
        line9_3: '树脂改性、合成树脂制造风电、汽车、家电',
        line9_4: '树脂改性、合成树脂制造,接着剂、复合材料、遮阳板、周转箱、手套、塑料改性基料',

        line10_1: '电子材料',
        line10_2: '显示器用材料,铜箔、聚酰亚胺膜,铜箔、聚酰亚胺膜,有机发光材料,绝缘膜，半导体材料,散热材料',
        line10_3: '显示面板(FPC.OLED),电子线路板,半导体移动出行,半导体',
        line10_4: '智能手机、电视机，工业用薄膜',

        line11_1: '新事业开发',
        line11_2: '电工级别聚丙烯薄膜，树脂,芯片低温实装,离型膜(PE/PET)',
        line11_3: '移动出行,半导体',
        line11_4: '新能源汽车,电子部件',


        line12_1: '广州机能材料',
        line12_2: 'PVC、茂金属PE、PE、EVA、CR、TAFMER、PC及其他工程塑料， 汽车减震降噪材料， PI膜、铜箔、离型膜、离型纸,气压缩机, 工业产线自动化',
        line12_3: '塑料包装,塑料板材,塑料改性,汽车部品, 橡胶成型印制电路板,鞋材,氢气新能源,工业自动化',
        line12_4: '食品包装,工业包装,传»诜盪麿陛泙是垮汽车，家电，智能手机, 新能源汽车电池,卫生材料,电线电缆,粘合剂,生活耗材高级EVA发泡鞋底,气气加压充填',
    },
    stock: {
        tit1: 'No.',
        tit2: '地域',
        tit3: '在库种类',

        area1: '上海地区',
        area2: '华东地区',
        area3: '华南地区',

        hz: '杭州',
        //ks: '昆山',
        sz: '苏州',
        //tc: '太仓',
        nb: '宁波',
        nt: '南通',
        zjg: '张家港',

        tj: '天津',
        dl: '大连',     
        qd: '青岛',
        sy: '沈阳',
        cc: '长春',
        wh: '武汉',
        cq: '重庆',
        cd: '成都',
        xm: '厦门',
        gz: '广州',
        dw: '东莞',
        shz: '深圳',

        bsq: '保税区',
        bswlyq: '保税物流园区',
        yb: '一般',
        wxp: '危险品',
        ckjgq: '出口加工区',
        c1: '（1处）',//危险品
        c2: '（0处）',//保税物流园区
        c3: '（1处）',//保税区
        c5: '（5处）',//一般
        c6: '（6处）',//一般
    },
    contact: {
        title: '如有需要，欢迎通过以下方式垂询',
    }
}


